import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const createNewQuoteReq = async (data: any) => {
  return await axiosInstance
    .post("req/quotes/requestSingleAutomated", data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useCreateNewQuoteReq = () => {
  return useMutation({
    mutationFn: (data: any) => createNewQuoteReq(data),
    mutationKey: ["quote", "new"],
  });
};

export default useCreateNewQuoteReq;
